import { Checkbox, FormControlLabel } from '@mui/material';
import * as React from 'react';
import variable from '../style/variable';

interface ICheckboxProps {
    label: string;
    checked: boolean;
    handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const CheckboxCustom = (props: ICheckboxProps) => (
    <FormControlLabel
        control={
            <Checkbox
                checked={props.checked}
                sx={{
                    '&.Mui-checked': {
                        color: variable.greenLight,
                    },
                }}
                onChange={props.handleChange}
                inputProps={{ 'aria-label': 'controlled' }}
            />
        }
        label={props.label}
    />
);

export default CheckboxCustom;
